document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sort-form]').forEach((form) => {
    const select = form.querySelector('select');
    if (!select) return;
    select.addEventListener('change', () => form.submit());
  });

  document.querySelectorAll('[data-menu-details]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('[data-menu-details]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });
});